import { Disclosure, Transition } from "@headlessui/react";
import { BsPlusCircleDotted } from "react-icons/bs";
import H3 from "../../elements/titles/H3";

const DisclosureCore = ({ children, title }) => {
  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button
            className="flex w-full items-center justify-between rounded py-4 px-4"
            style={{ background: "#f4f4f4" }}
          >
            <H3 color={`${open && "primary"}`} classe="animate opacity-80">
              {title}
            </H3>
            <BsPlusCircleDotted
              className={`${
                open ? "rotate-90 transform" : ""
              } animate opacity-80`}
              color={`${open ? "#FF6600" : "#0b1012"}`}
              size={18}
            />
          </Disclosure.Button>

          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel static className="w-full py-3 px-4">
              {children}
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
};

export default DisclosureCore;
